import { ajax } from '@/api/ajax';

export interface FileIdsReq {
  needCdn?: boolean;
  splicingFileIds?: string;
}

export type ListByFileIdsUsingPostApiResponse = EapSysAttachmentQryResp[];

export interface EapSysAttachmentQryResp {
  billId?: string;
  createBy?: string;
  createTime?: string;
  fileDesc?: string;
  fileId?: string;
  fileName?: string;
  filePath?: string;
  fileSize?: number;
  fileType?: string;
  id?: number;
  isDeleted?: number;
  moduleCode?: string;
  sortNo?: number;
  updateBy?: string;
  updateTime?: string;
}

/**
 * @operationId listByFileIdsUsingPOST
 * @tags 公共接口
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-cms-cn-boot/doc.html#/CMS-%E5%85%AC%E5%85%B1/%E5%85%AC%E5%85%B1%E6%8E%A5%E5%8F%A3/listByFileIdsUsingPOST
 */
export function listByFileIdsUsingPost(data: FileIdsReq) {
  return ajax<ListByFileIdsUsingPostApiResponse>({
    url: '/api/tis/web/eapSysAttachment/listByFileIds',
    method: 'post',
    data: data
  });
}
